export default __webpack_public_path__ + "static/median-duration-light-mode-4d17e3325d6a15ead58e911321b1aa50.png";